import { render, staticRenderFns } from "./IconTools.vue?vue&type=template&id=6aed468c&"
import script from "./IconTools.vue?vue&type=script&lang=ts&"
export * from "./IconTools.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports